import { Component, Input } from "@angular/core";
import { IStepAssignee } from "src/app/interfaces";
import { LogClass, Logger } from "../../../logger";

@Component({
    selector: "circ-task-comment",
    templateUrl: "./task-comment.component.html",
    styleUrls: ["./task-comment.component.scss"],
    standalone: false
})
@LogClass({ source: "TaskCommentComponent" })
export class TaskCommentComponent {
  private logger: Logger;
  @Input() public assignee: IStepAssignee;

  constructor() {
    this.logger.debug("init");
  }
}
